import React from 'react';
import { IOrder } from '@/interfaces/order';
import { Col, Row, Steps } from 'antd';
import { formatDate } from '@/utils/dataUtils';
import { dateTimeFormat } from '@/configs/dateFormat';
import dayjs from 'dayjs';

interface IProps {
  data: IOrder;
}

const DeliveryStep = ({ data }: IProps) => {
  const delivery = data?.orderDelivery;
  return (
    <Row gutter={12}>
      <Col span={24}>
        <div className=" bg-gray-50 p-4 border-2 border-dashed rounded-md">
          <Steps
            items={[
              {
                title: 'ยืนยันส่งเอกสาร',
                description: `${(data?.confirmDate && formatDate(data?.confirmDate, dateTimeFormat)) || ''}`,
                status: data.isConfirm ? 'finish' : 'wait',
              },
              {
                title: 'CHECK IN',
                description:
                  (delivery?.checkInDate &&
                    formatDate(dayjs(delivery?.checkInDate), dateTimeFormat)) ||
                  '',
                status: delivery?.checkInDate ? 'finish' : 'wait',
              },
              {
                title: 'ON DELIVERY',
                description:
                  (delivery?.onDeliveryDate &&
                    formatDate(
                      dayjs(delivery?.onDeliveryDate),
                      dateTimeFormat,
                    )) ||
                  '',
                status: delivery?.onDeliveryDate ? 'finish' : 'wait',
              },
              {
                title: 'CHECK OUT',
                description:
                  (delivery?.checkoutDate &&
                    formatDate(
                      dayjs(delivery?.checkoutDate),
                      dateTimeFormat,
                    )) ||
                  '',
                status: delivery?.checkoutDate ? 'finish' : 'wait',
              },
              {
                title: 'DELIVERYED',
                description:
                  (delivery?.deliveryedDate &&
                    formatDate(
                      dayjs(delivery?.deliveryedDate),
                      dateTimeFormat,
                    )) ||
                  '',
                status: delivery?.deliveryedDate ? 'finish' : 'wait',
              },
            ]}
          />
        </div>
      </Col>
    </Row>
  );
};

export default DeliveryStep;
